webpackJsonp([35783957827783],{

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	__webpack_require__(591);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function Menu(_ref) {
	  var latestExp = _ref.latestExp;
	  return _react2.default.createElement(
	    'ul',
	    { className: 'home__menu' },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/experiments' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Experiments'
	        )
	      ),
	      _react2.default.createElement(
	        'h4',
	        { style: { marginTop: '10px' } },
	        'latest: ',
	        _react2.default.createElement(
	          'strong',
	          { style: { letterSpacing: '1px' } },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: latestExp.fields.slug },
	            latestExp.frontmatter.title
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/work' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Work & Experience'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/projects' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Projects'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/about' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'About Me'
	        )
	      )
	    )
	  );
	};
	
	var ContactForm = function ContactForm() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact', id: 'contact' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Contact'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '525px', margin: '50px auto 50px auto', textAlign: 'center' } },
	        _react2.default.createElement(
	          'p',
	          null,
	          "Yes. I'm available for freelance data viz and website design/dev work!"
	        )
	      ),
	      _react2.default.createElement(
	        'form',
	        { action: 'https://formspree.io/andrewlomaxr@gmail.com',
	          method: 'POST' },
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'name' },
	            'Name'
	          ),
	          _react2.default.createElement('input', { type: 'text', name: 'name' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: '_replyto' },
	            'Email'
	          ),
	          _react2.default.createElement('input', { type: 'email', name: '_replyto' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'message' },
	            'Message'
	          ),
	          _react2.default.createElement('textarea', { name: 'message', rows: '6' })
	        ),
	        _react2.default.createElement('input', { type: 'submit', value: 'Send' })
	      )
	    )
	  );
	};
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    var projects = this.props.data.allMarkdownRemark.edges;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'page home' },
	      _react2.default.createElement(Menu, { latestExp: projects[0].node }),
	      _react2.default.createElement(ContactForm, null)
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-55ad22876e6049269248.js